export default "__VITE_ASSET__DcWW9A_K__"